import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { XStack } from 'tamagui';

import { Text } from '@/components/text';
import { useIsOnline } from '@/lib/network';
import { borderWidth } from '@/theme/tokens.generated';

// Issue #152 AC1: a real, live NetInfo-driven banner -- not a per-
// screen error copy (design.md's own critique: "offline currently =
// per-screen error copy only"). Persistent, not a Toast: unlike a
// transient success/error notification, "you're offline" stays true
// until it isn't, so it has no auto-dismiss and no close button --
// pairs with network.ts's onlineManager wiring, which is what actually
// makes every mutation queue/retry on reconnect underneath this.
export function OfflineBanner() {
  const isOnline = useIsOnline();
  const insets = useSafeAreaInsets();

  if (isOnline) return null;

  return (
    <XStack
      role="status"
      backgroundColor="$feedbackWarningBg"
      borderBottomWidth={borderWidth.hairline}
      borderBottomColor="$feedbackWarningBorder"
      justifyContent="center"
      px="$4"
      py="$2"
      pt={insets.top + 8}
    >
      <Text color="$feedbackWarningText" fontSize="$meta" lineHeight="$meta" fontWeight="$semibold" textAlign="center">
        You&apos;re offline. Anything you post or send will go out when you&apos;re back.
      </Text>
    </XStack>
  );
}
